import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { GoogleService } from '../../../services/google.service';
import { AuthService } from 'src/app/services/auth.service';
import * as dayjs from 'dayjs';
import { HourglassService } from 'src/app/services/hourglass.service';

@Component({
  selector: 'app-calendar-slim',
  templateUrl: './calendar-slim.component.html',
  styleUrls: ['./calendar-slim.component.css']
})
export class CalendarSlimComponent implements OnInit {
  @Input() showAddButton = true;
  @Input() targetObject!: string;
  @Output() calendarToEntry = new EventEmitter<string>();
  token!: string;
  events: any[] = [];
  userId: any = sessionStorage.getItem("wOSAuthUser");
  fromDt: any = "";
  thruDt: any = "";
  
  constructor(
    private googleService: GoogleService,
    private hourglassService: HourglassService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    const tokenuser: any = sessionStorage.getItem("wOSUser");
    this.token = JSON.parse(tokenuser).stsTokenManager.accessToken;
    this.loadCalendarEvents();
  }

  eventDateTracker(index: any, item: any) {
    return item.id; // Use the 'id' property as the unique identifier
  }

  loadCalendarEvents(): void {
    this.googleService.getCalendarEventsWeekly(this.fromDt,this.thruDt,this.token).subscribe({
      next: (data) => {
        this.events = data.items.filter((event: { visibility: string; }) => event.visibility != 'private')

        if (this.targetObject === undefined) this.targetObject = "entryCalendar";

        setTimeout(() => {
          const today = dayjs(Date.now()).format('ddd_D_MMM');
          const scrollerpos: any = $('#' + this.targetObject).position().top;
          const dtpos: any = $('#' + today).offset();

          $('#' + this.targetObject)[0].scrollTo(0, dtpos.top - scrollerpos);
        })
      },
      error: (err) => {
        console.error("Error fetching Google Calendar events:", err);
      }
    });
  }

  // look up task by calendar.summary and return the ID - zero if not found
  calToEntry(params: any): void {
    const taskSummary = params.summary;
    this.hourglassService.lookupTask(taskSummary, this.userId, this.token).then(r => {
      params.returnID = r;
      this.calendarToEntry.emit(params);
    })
  }

  refreshWeekData(params: any): void {
    this.loadCalendarEvents();
  }
}
